module.exports = __webpack_public_path__ + "img/swords-laser.7de88308.svg";